import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { filter, map } from 'rxjs';
import { AppStateService } from 'shared/services/app-state/app-state.service';

@Component({
  selector: 'app-logged-out',
  imports: [AsyncPipe],
  templateUrl: './logged-out.component.html'
})
export class LoggedOutComponent {
  private appState = inject(AppStateService);
  content$ = this.appState.get$('contentItemCollection')
    .pipe(
      filter(collection => !!collection),
      map(collection => {
        return collection['family-logged-out'];
      })
    )

}
